<template>
    <div>
        <div style="height:80px" aria-hidden="true" class="wp-block-spacer"></div>
        <div id="" class="zb-text-block sm_text-align-center">
            <h2 class="zb-text lg_txt-title-lg-alt sm_txt-title-md-alt text-align-left has-focus-90-color">Types of Office Actions</h2>
        </div>
        <div style="height:18px" aria-hidden="true" class="wp-block-spacer"></div>
        <div id="" class="zb-text-block sm_text-align-center">

            <p class="zb-text lg_txt-body-lg sm_txt-body-md text-align-left has-focus-60-color">
                Principally, there are two main types of office actions; Procedural Trademark Office Actions and Substantive Trademark Office Actions. Below is a summary of each type.
            </p>

        </div>
        <div id="business-types" class="paid-business-types-comparison-text-v2">

            <div class="zb-hide-below-sm is-style-grid-full paid-business-types-comparison-text-v2--wrapper">

                <div class="paid-business-types-comparison-text-v2--row paid-business-types-comparison-text-v2--heading-row" data-columns="3">
                    <h2 class="paid-business-types-comparison-text-v2--heading txt-title-sm txt-bold has-focus-70-color" data-heading="0">
                        Office Actions            </h2>
                    <div class="paid-business-types-comparison-text-v2--heading txt-body-md txt-bold has-focus-70-color" data-heading="1">
                        Common            </div>
                    <div class="paid-business-types-comparison-text-v2--heading txt-body-md txt-bold has-focus-70-color" data-heading="2">
                        Procedural            </div>
                    <div class="paid-business-types-comparison-text-v2--heading txt-body-md txt-bold has-focus-70-color" data-heading="3">
                        Objections            </div>
                </div>

                <div class="paid-business-types-comparison-text-v2--sections">

                    <div class="paid-business-types-comparison-text-v2--section">

                        <div class="paid-business-types-comparison-text-v2--row" data-columns="3">

                            <div class="paid-business-types-comparison-text-v2--section-intro">

                                <h3 class="paid-business-types-comparison-text-v2--section-heading
                                            txt-title-md txt-bold">
                                    Procedural                        </h3><!-- section-heading -->

                                <p class="txt-caption-md has-focus-60-color sub-label">
                                    A straight forward office action that is relatively simple and inexpensive to complete                        </p>

                                <div class="paid-business-types-comparison-text-v2--section-cta-button">

                                    <a @click.prevent="to" href="" aria-label="Start an LLC" data-schema="cta" data-destination="funnel" data-entitytype="llc" class="zb-button txt-button-lg button-growth button-primary ">
                                        Submit Response
                                    </a>
                                </div><!-- section-cta-button -->
                            </div><!-- section-intro -->

                            <div class="paid-business-types-comparison-text-v2--section-data txt-body-sm">
                                <p>Disclaimer needed.</p>
                                <p>Word needs to be translated.</p>
                                <p>Living person disclaimer or consent needed.</p>
                                <p>Improper specimen for proof-of-use.</p>
                            </div><!-- section-data -->
                            <div class="paid-business-types-comparison-text-v2--section-data txt-body-sm">
                                <p>Incorrect description or color claim of the mark.</p>
                                <p>Incorrect identification or class of goods/services.</p>
                                <p>Notice of Allowance issued. Statement/Declaration of Use needed.</p>
                                <p>Improper signature/signature needed.</p>
                            </div><!-- section-data -->
                            <div class="paid-business-types-comparison-text-v2--section-data txt-body-sm">
                                <p>Supplemental Register amendment suggested.</p>
                                <p>The trademark is misleading or deceptive.</p>
                                <p>The trademark is "primarily a surname".</p>
                                <p>I Don't Know Why My Application Was Rejected.</p>
                            </div><!-- section-data -->

                        </div> <!-- row -->

                    </div><!-- section -->
                    <div class="paid-business-types-comparison-text-v2--section">

                        <div class="paid-business-types-comparison-text-v2--row paid-business-types-comparison-text-v2--row-2" data-columns="3">

                            <div class="paid-business-types-comparison-text-v2--section-intro">

                                <h3 class="paid-business-types-comparison-text-v2--section-heading
                                            txt-title-md txt-bold">
                                    Substantive                       </h3><!-- section-heading -->

                                <p class="txt-caption-md has-focus-60-color sub-label">
                                    A more complex office action requiring the drafting of a legal brief                       </p>

                                <div class="paid-business-types-comparison-text-v2--section-cta-button">

                                    <a @click.prevent="to" href="" aria-label="Start a C-Corp" data-schema="cta" data-destination="funnel" data-entitytype="c-corp" class="zb-button txt-button-lg button-growth button-primary ">
                                        Submit Response
                                    </a>
                                </div><!-- section-cta-button -->

                            </div><!-- section-intro -->

                            <div class="paid-business-types-comparison-text-v2--section-data txt-body-sm">
                                <p>The trademark is "merely descriptive".</p>
                                <p>The trademark is too similar to an existing trademark.</p>
                            </div><!-- section-data -->
                            <div class="paid-business-types-comparison-text-v2--section-data txt-body-sm">
                                <p>SOLUTION: A Licensed Attorney will draft a multi-page legal brief explaining why there is there is no Likelihood of Confusion and/or Descriptive Issue with your Trademark</p>
                            </div><!-- section-data -->

                        </div> <!-- row -->

                    </div><!-- section -->
                </div><!-- sections -->
            </div><!-- desktop version -->

            <div class="zb-hide-above-sm is-style-grid-full paid-business-types-comparison-text-v2--wrapper">
                <h2 class="txt-title-hg paid-business-types-comparison-text-v2--heading">
                    Business Types            </h2>
                <div class="">
                    <div class="">
                        <div class="paid-business-types-comparison-text-v2--section-mobile">
                            <h3 class="main-label">
                                <span class="txt-title-md txt-bold">
                                    Procedural                            </span>
                            </h3>
                            <p class="txt-body-md has-focus-90-color sub-label">
                                The simplest and most flexible way to structure your business to protect personal assets                        </p>
                            <div class="paid-business-types-comparison-text-v2--section-cta-button">

                                <a @click.prevent="to" href="" aria-label="Start an LLC" data-schema="cta" data-destination="funnel" data-entitytype="llc" class="zb-button txt-button-lg button-growth button-primary ">

                                    Start an Procedural
                                </a>
                            </div><!-- section-cta-button -->

                            <div class="">
                                <div class="paid-business-types-comparison-text-v2--data-heading
                                                    txt-body-xl txt-bold">
                                    How It’s Unique                                    </div>
                                <div class="paid-business-types-comparison-text-v2--section-data txt-body-md">
                                    <p>Disclaimer needed.</p>
                                    <p>Word needs to be translated.</p>
                                    <p>Living person disclaimer or consent needed.</p>
                                    <p>Improper specimen for proof-of-use.</p>
                                </div><!-- section-data -->
                                <div class="paid-business-types-comparison-text-v2--data-heading
                                                    txt-body-xl txt-bold">
                                    Protections &amp; Taxation                                    </div>
                                <div class="paid-business-types-comparison-text-v2--section-data txt-body-md">
                                    <p>Incorrect description or color claim of the mark.</p>
                                    <p>Incorrect identification or class of goods/services.</p>
                                    <p>Notice of Allowance issued. Statement/Declaration of Use needed.</p>
                                    <p>Improper signature/signature needed.</p>
                                </div><!-- section-data -->
                                <div class="paid-business-types-comparison-text-v2--data-heading
                                                    txt-body-xl txt-bold">
                                    Drawbacks to Consider                                    </div>
                                <div class="paid-business-types-comparison-text-v2--section-data txt-body-md">
                                    <p>Supplemental Register amendment suggested.</p>
                                    <p>The trademark is misleading or deceptive.</p>
                                    <p>The trademark is "primarily a surname".</p>
                                    <p>I Don't Know Why My Application Was Rejected.</p>
                                </div><!-- section-data -->

                            </div>
                        </div>
                        <div class="paid-business-types-comparison-text-v2--section-mobile">
                            <h3 class="main-label">
                                <span class="txt-title-md txt-bold">
                                    Substantive                            </span>
                            </h3>
                            <p class="txt-body-md has-focus-90-color sub-label">
                                A more complex structure that gives you the ability to issue shares, go public, or go global.                        </p>
                            <div class="paid-business-types-comparison-text-v2--section-cta-button">

                                <a @click.prevent="to" href="" aria-label="Start a C-Corp" data-schema="cta" data-destination="funnel" data-entitytype="c-corp" class="zb-button txt-button-lg button-growth button-primary ">

                                    Start a Substantive
                                </a>
                            </div><!-- section-cta-button -->

                            <div class="">
                                <div class="paid-business-types-comparison-text-v2--data-heading
                                                    txt-body-xl txt-bold">
                                    How It’s Unique                                    </div>
                                <div class="paid-business-types-comparison-text-v2--section-data txt-body-md">
                                    <p>The trademark is "merely descriptive".</p>
                                    <p>The trademark is too similar to an existing trademark.</p>
                                </div><!-- section-data -->
                                <div class="paid-business-types-comparison-text-v2--data-heading
                                                    txt-body-xl txt-bold">
                                    Protections &amp; Taxation                                    </div>
                                <div class="paid-business-types-comparison-text-v2--section-data txt-body-md">
                                    <p>SOLUTION: A Licensed Attorney will draft a multi-page legal brief explaining why there is there is no Likelihood of Confusion and/or Descriptive Issue with your Trademark</p>
                                </div><!-- section-data -->


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- mobile version -->
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        to() {
            this.$router.push({ path: '/trademark-office-action/info' })
        }
    }
}
</script>
<style scoped>
h2 {
    margin: 0!important;
}
p {
    display: block;
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/assets/css/imports.css?ver=1685037282 ; media=all */
@media all{
    *{box-sizing:border-box;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);}
    a,div,h2,h3,p,span{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;font-weight:inherit;vertical-align:baseline;}
    a{text-decoration:none;font-size:inherit;color:#002FCF;}
    a:active{color:#002FCF;}
    a:focus,a:hover{color:#0226A6;}
    p{margin-bottom:15px;}
    .txt-body-md,.txt-body-sm,.txt-body-xl,.txt-button-lg,.txt-caption-md,.txt-title-md,.txt-title-sm{font-family:"Inter","Trebuchet_MS",sans-serif;}
    .txt-title-hg{font-family:"Montserrat","Verdana",sans-serif;;}
    .txt-title-hg{font-weight:900;}
    .txt-button-lg,.txt-title-md{font-weight:600;}
    .txt-body-md,.txt-body-sm,.txt-body-xl,.txt-caption-md,.txt-title-sm{font-weight:400;}
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .txt-title-hg{font-size:2.25rem;line-height:2.625rem;letter-spacing:-1px;}
        .txt-title-md{font-size:1.5rem;line-height:1.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.25rem;line-height:1.5rem;letter-spacing:-.5px;}
        .txt-body-xl{font-size:1.125rem;line-height:1.6875rem;}
        .txt-body-md{font-size:.9375rem;line-height:1.4375rem;}
        .txt-body-sm{font-size:.875rem;line-height:1.3125rem;}
        .txt-button-lg{font-size:1rem;line-height:1.25rem;}
        .txt-caption-md{font-size:.75rem;line-height:1rem;}
    }
    @media screen and (min-width:960px){
        .txt-title-hg{font-size:4rem;line-height:4.8125rem;letter-spacing:-1px;}
        .txt-title-md{font-size:2.25rem;line-height:2.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.75rem;line-height:2.125rem;letter-spacing:-.5px;}
        .txt-body-xl{font-size:1.5rem;line-height:2.25rem;}
        .txt-body-md{font-size:1.125rem;line-height:1.6875rem;}
        .txt-body-sm{font-size:1rem;line-height:1.5rem;}
        .txt-button-lg{font-size:1.25rem;line-height:1.5rem;}
        .txt-caption-md{font-size:.75rem;line-height:.9375rem;}
    }
    .is-style-grid-full{max-width:1232px;margin:0 auto;padding:0 16px;display:grid;grid-template-columns:repeat(4,1fr);-moz-column-gap:16px;column-gap:16px;}
    .is-style-grid-full>*{margin-bottom:30px;grid-column:1/5;}
    @media screen and (min-width:960px){
        .is-style-grid-full{grid-template-columns:repeat(8,1fr);}
        .is-style-grid-full>*{grid-column:1/9;}
    }
    @media screen and (min-width:1280px){
        .is-style-grid-full{grid-template-columns:repeat(12,1fr);-moz-column-gap:24px;column-gap:24px;}
        .is-style-grid-full>*{grid-column:1/13;}
    }
    .txt-body-md,.txt-body-sm,.txt-body-xl,.txt-button-lg,.txt-caption-md,.txt-title-md,.txt-title-sm{font-family:"Inter","Trebuchet_MS",sans-serif;}
    .txt-title-hg{font-family:"Montserrat","Verdana",sans-serif;;}
    .txt-title-hg{font-weight:900;}
    .txt-button-lg,.txt-title-md{font-weight:600;}
    .txt-body-md,.txt-body-sm,.txt-body-xl,.txt-caption-md,.txt-title-sm{font-weight:400;}
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .txt-title-hg{font-size:2.25rem;line-height:2.625rem;letter-spacing:-1px;}
        .txt-title-md{font-size:1.5rem;line-height:1.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.25rem;line-height:1.5rem;letter-spacing:-.5px;}
        .txt-body-xl{font-size:1.125rem;line-height:1.6875rem;}
        .txt-body-md{font-size:.9375rem;line-height:1.4375rem;}
        .txt-body-sm{font-size:.875rem;line-height:1.3125rem;}
        .txt-button-lg{font-size:1rem;line-height:1.25rem;}
        .txt-caption-md{font-size:.75rem;line-height:1rem;}
    }
    @media screen and (min-width:960px){
        .txt-title-hg{font-size:4rem;line-height:4.8125rem;letter-spacing:-1px;}
        .txt-title-md{font-size:2.25rem;line-height:2.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.75rem;line-height:2.125rem;letter-spacing:-.5px;}
        .txt-body-xl{font-size:1.5rem;line-height:2.25rem;}
        .txt-body-md{font-size:1.125rem;line-height:1.6875rem;}
        .txt-body-sm{font-size:1rem;line-height:1.5rem;}
        .txt-button-lg{font-size:1.25rem;line-height:1.5rem;}
        .txt-caption-md{font-size:.75rem;line-height:.9375rem;}
    }
    @media screen and (min-width:960px){
        .zb-hide-above-sm{display:none;}
    }
    @media screen and (max-width:959px){
        .zb-hide-below-sm{display:none;}
    }
    .has-focus-60-color{color:#424242;}
    .has-focus-70-color{color:#2e2e2e;}
    .has-focus-90-color{color:#000;}
    .zb-button{border:2px solid transparent;border-radius:16px;cursor:pointer;padding:15px 25px;text-align:center;text-decoration:none;transition-duration:.4s;width:100%;display:inline-flex;align-items:center;justify-content:center;-moz-column-gap:16px;column-gap:16px;}
    .zb-button:active,.zb-button:focus{box-shadow:none;outline:0;transform:scale(.98);}
    .zb-button:disabled{cursor:not-allowed;}
    .zb-button.button-growth.button-primary{background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);color:#000000;}
    .zb-button.button-growth.button-primary:visited{background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);}
    .zb-button.button-growth.button-primary:focus,.zb-button.button-growth.button-primary:hover{background-color:rgb(3 148 159);border-color:rgb(3 148 159);}
    .zb-button.button-growth.button-primary:active{box-shadow:none;background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);}
    .zb-button.button-growth.button-primary:disabled{background-color:#C7C7C7;border-color:#C7C7C7;}
    @media screen and (min-width:960px){
        .zb-button{max-width:100%;width:auto;}
    }
    .txt-body-md,.txt-body-sm,.txt-body-xl,.txt-button-lg,.txt-caption-md,.txt-title-md,.txt-title-sm{font-family:"Inter","Trebuchet_MS",sans-serif;}
    .txt-title-hg{font-family:"Montserrat","Verdana",sans-serif;;}
    .txt-title-hg{font-weight:900;}
    .txt-button-lg,.txt-title-md{font-weight:600;}
    .txt-body-md,.txt-body-sm,.txt-body-xl,.txt-caption-md,.txt-title-sm{font-weight:400;}
    .txt-bold{font-weight:600;}
    @media screen and (max-width:959px){
        .txt-title-hg{font-size:2.25rem;line-height:2.625rem;letter-spacing:-1px;}
        .txt-title-md{font-size:1.5rem;line-height:1.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.25rem;line-height:1.5rem;letter-spacing:-.5px;}
        .txt-body-xl{font-size:1.125rem;line-height:1.6875rem;}
        .txt-body-md{font-size:.9375rem;line-height:1.4375rem;}
        .txt-body-sm{font-size:.875rem;line-height:1.3125rem;}
        .txt-button-lg{font-size:1rem;line-height:1.25rem;}
        .txt-caption-md{font-size:.75rem;line-height:1rem;}
    }
    @media screen and (min-width:960px){
        .txt-title-hg{font-size:4rem;line-height:4.8125rem;letter-spacing:-1px;}
        .txt-title-md{font-size:2.25rem;line-height:2.75rem;letter-spacing:-1px;}
        .txt-title-sm{font-size:1.75rem;line-height:2.125rem;letter-spacing:-.5px;}
        .txt-body-xl{font-size:1.5rem;line-height:2.25rem;}
        .txt-body-md{font-size:1.125rem;line-height:1.6875rem;}
        .txt-body-sm{font-size:1rem;line-height:1.5rem;}
        .txt-button-lg{font-size:1.25rem;line-height:1.5rem;}
        .txt-caption-md{font-size:.75rem;line-height:.9375rem;}
    }
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/ui-parts/blocks/paid-business-types-comparison-text-v2/paid-business-types-comparison-text-v2.css?ver=1685037282 ; media=all */
@media all{
    .paid-business-types-comparison-text-v2{display:block;text-align:left;padding:20px 0 80px;}
    .paid-business-types-comparison-text-v2--row{display:grid;grid-template-columns:repeat(2,1fr);justify-content:start;align-items:start;gap:21px;padding:24px 0;}
    .paid-business-types-comparison-text-v2--row[data-columns="3"]{grid-template-columns:repeat(4,1fr);}
    .paid-business-types-comparison-text-v2--heading-row{align-items:end;margin-bottom:0;}
    .paid-business-types-comparison-text-v2--heading{display:none;}
    @media screen and (min-width:960px){
        .paid-business-types-comparison-text-v2--heading{display:block;}
    }
    .paid-business-types-comparison-text-v2--wrapper{padding:0;}
    .paid-business-types-comparison-text-v2--section{border-bottom:1px solid #787878;}
    .paid-business-types-comparison-text-v2--section-heading{padding-bottom:24px;display:none;}
    @media screen and (min-width:600px){
        .paid-business-types-comparison-text-v2--section-heading{display:block;}
    }
    .paid-business-types-comparison-text-v2--section-cta-button{padding-bottom:16px;}
    .paid-business-types-comparison-text-v2--section-cta-button .zb-button{box-shadow:none!important;}
    .paid-business-types-comparison-text-v2--section-mobile{border-bottom:1px solid #787878;margin-bottom:50px;margin-top:10px;}
    .paid-business-types-comparison-text-v2--section-mobile:last-child{margin-bottom:0;}
    .paid-business-types-comparison-text-v2--data-heading{padding:8px 0;}
    .paid-business-types-comparison-text-v2 .paid-business-types-comparison-text-v2--section-price{text-align:center;}
    .paid-business-types-comparison-text-v2 .main-label{padding-bottom:16px;}
    @media screen and (min-width:960px){
        .paid-business-types-comparison-text-v2 .sub-label{margin-bottom:32px;max-width:232px;}
        .paid-business-types-comparison-text-v2 .paid-business-types-comparison-text-v2--section-heading{padding-bottom:16px;}
        .paid-business-types-comparison-text-v2 .paid-business-types-comparison-text-v2--section-price{text-align:left;}
    }
    @media screen and (min-width:600px){
        .paid-business-types-comparison-text-v2 .paid-business-types-comparison-text-v2--section-data{padding-top:48px;}
    }
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/assets/css/rebrand.css?ver=1685037282 ; media=all */
@media all{
    .rebrand-2022 .zb-button{border:2px solid transparent;border-radius:16px;cursor:pointer;padding:15px 25px;text-align:center;text-decoration:none;transition-duration:.4s;width:100%;display:inline-flex;align-items:center;justify-content:center;-moz-column-gap:16px;column-gap:16px;}
    .rebrand-2022 .zb-button:active,.rebrand-2022 .zb-button:focus{box-shadow:none;outline:0;transform:scale(.98);}
    .rebrand-2022 .zb-button:disabled{cursor:not-allowed;}
    .rebrand-2022 .zb-button.button-growth.button-primary{background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);color:#000000;}
    .rebrand-2022 .zb-button.button-growth.button-primary:visited{background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);}
    .rebrand-2022 .zb-button.button-growth.button-primary:focus,.rebrand-2022 .zb-button.button-growth.button-primary:hover{background-color:rgb(3 148 159);border-color:rgb(3 148 159);}
    .rebrand-2022 .zb-button.button-growth.button-primary:active{box-shadow:none;background-color:rgb(0, 193, 207);border-color:rgb(0, 193, 207);}
    .rebrand-2022 .zb-button.button-growth.button-primary:disabled{background-color:#C7C7C7;border-color:#C7C7C7;}
    @media screen and (min-width:960px){
        .rebrand-2022 .zb-button{max-width:100%;width:auto;}
    }
}
.paid-business-types-comparison-text-v2--section-data p{
    line-height: 24px!important;
}
.paid-business-types-comparison-text-v2--row-2 {
    grid-template-columns: 1fr 1fr 2fr!important;
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/assets/css/imports.css?ver=1686238777 ; media=all */
@media all{
    *{box-sizing:border-box;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);}
    p{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;font-weight:inherit;vertical-align:baseline;}
    p{margin-bottom:15px;}
    .lg_txt-title-lg-alt,.sm_txt-title-md-alt{font-family:"Montserrat","Verdana",sans-serif;;}
    @media screen and (min-width:960px){
        .lg_txt-title-lg-alt{font-weight:800;}
    }
    @media screen and (max-width:959px){
        .sm_txt-title-md-alt{font-weight:800;}
    }
    @media screen and (max-width:959px){
        .sm_txt-title-md-alt{font-size:1.5rem;line-height:1.75rem;letter-spacing:-1px;}
    }
    @media screen and (min-width:960px){
        .lg_txt-title-lg-alt{font-size:3rem;line-height:3.625rem;letter-spacing:-1px;}
    }
    .text-align-left{text-align:left;}
    .lg_txt-title-lg-alt,.sm_txt-title-md-alt{font-family:"Montserrat","Verdana",sans-serif;}
    @media screen and (min-width:960px){
        .lg_txt-title-lg-alt{font-weight:800;}
    }
    @media screen and (max-width:959px){
        .sm_txt-title-md-alt{font-weight:800;}
    }
    @media screen and (max-width:959px){
        .sm_txt-title-md-alt{font-size:1.5rem;line-height:1.75rem;letter-spacing:-1px;}
    }
    @media screen and (min-width:960px){
        .lg_txt-title-lg-alt{font-size:3rem;line-height:3.625rem;letter-spacing:-1px;}
    }
    .text-align-left{text-align:left;}
    .has-focus-90-color{color:#000;}
    .lg_txt-title-lg-alt,.sm_txt-title-md-alt{font-family:"Montserrat","Verdana",sans-serif;}
    @media screen and (min-width:960px){
        .lg_txt-title-lg-alt{font-weight:800;}
    }
    @media screen and (max-width:959px){
        .sm_txt-title-md-alt{font-weight:800;}
    }
    @media screen and (max-width:959px){
        .sm_txt-title-md-alt{font-size:1.5rem;line-height:1.75rem;letter-spacing:-1px;}
    }
    @media screen and (min-width:960px){
        .lg_txt-title-lg-alt{font-size:3rem;line-height:3.625rem;letter-spacing:-1px;}
    }
    .text-align-left{text-align:left;}
    .zb-text{width:100%;margin:0 auto;}
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/ui-parts/blocks/text/text.css?ver=1686238777 ; media=all */
@media all{
    .zb-text-block.sm_text-align-center .zb-text{text-align:center;}
    @media screen and (min-width:960px){
        .zb-text-block.sm_text-align-center .zb-text{text-align:inherit;}
    }
}

/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/assets/css/imports.css?ver=1686238777 ; media=all */
@media all{
    *{box-sizing:border-box;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:rgba(0,0,0,0);}
    div,p{margin:0;padding:0;border:0;font-size:100%;font-family:inherit;font-weight:inherit;vertical-align:baseline;}
    p{margin-bottom:15px;}
    .lg_txt-body-lg,.sm_txt-body-md{font-family:var(--t-primary-font);}
    @media screen and (min-width:960px){
        .lg_txt-body-lg{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-size:.9375rem;line-height:1.4375rem;}
    }
    @media screen and (min-width:960px){
        .lg_txt-body-lg{font-size:1.25rem;line-height:1.875rem;}
    }
    .text-align-left{text-align:left;}
    .lg_txt-body-lg,.sm_txt-body-md{font-family:var(--t-primary-font);}
    @media screen and (min-width:960px){
        .lg_txt-body-lg{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-size:.9375rem;line-height:1.4375rem;}
    }
    @media screen and (min-width:960px){
        .lg_txt-body-lg{font-size:1.25rem;line-height:1.875rem;}
    }
    .text-align-left{text-align:left;}
    .has-focus-60-color{color:#424242;}
    .lg_txt-body-lg,.sm_txt-body-md{font-family:var(--t-primary-font);}
    @media screen and (min-width:960px){
        .lg_txt-body-lg{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-weight:400;}
    }
    @media screen and (max-width:959px){
        .sm_txt-body-md{font-size:.9375rem;line-height:1.4375rem;}
    }
    @media screen and (min-width:960px){
        .lg_txt-body-lg{font-size:1.25rem;line-height:1.875rem;}
    }
    .text-align-left{text-align:left;}
    .zb-text{width:100%;margin:0 auto;}
}
/*! CSS Used from: https://www.zenbusiness.com/wp-content/themes/zenbusiness/ui-parts/blocks/text/text.css?ver=1686238777 ; media=all */
@media all{
    .zb-text-block.sm_text-align-center .zb-text{text-align:center;}
    @media screen and (min-width:960px){
        .zb-text-block.sm_text-align-center .zb-text{text-align:inherit;}
    }
}
</style>
